export const NUKRISHI_URL = "https://www.nukrishi.com";

// TODO: placeholder — replace once American Bulls' real domain is live.
export const AMERICANBULLS_URL = "https://www.americanbulls.in";
